import { createContext, useContext, useMemo, useState } from "react";

const QuoteCtx = createContext(null);

export function QuoteProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const add = (p) =>
    setItems((prev) =>
      prev.find((i) => i.slug === p.slug)
        ? prev.map((i) => (i.slug === p.slug ? { ...i, qty: i.qty + 1 } : i))
        : [...prev, { slug: p.slug, name: p.name, price: p.price, qty: 1 }]
    );
  const setQty = (slug, qty) => setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, qty: Math.max(1, qty) } : i)));
  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);
  const [presetType, setPresetType] = useState(null);
  const openDrawer = (preset) => {
    if (preset) setPresetType(preset);
    setOpen(true);
  };
  const closeDrawer = () => setOpen(false);

  const value = useMemo(
    () => ({ items, add, setQty, remove, clear, open, openDrawer, closeDrawer, presetType, count: items.reduce((a, i) => a + i.qty, 0) }),
    [items, open, presetType]
  );

  return <QuoteCtx.Provider value={value}>{children}</QuoteCtx.Provider>;
}

export const useQuote = () => useContext(QuoteCtx);
